/*
 * @Author: wupeiwen <javapeiwen2010@gmail.com>
 * @Date: 2022-06-06 17:20:03
 * @LastEditors: wupeiwen <javapeiwen2010@gmail.com>
 * @LastEditTime: 2022-06-30 10:18:07
 * @FilePath: /jy-dashboard-web/src/util/storeModules/production-management.js
 * @Description: 生产管理
 */
import { get } from '@/util/http.js'
export default {
  state: {
    loading: {},
    // 地图统计
    dttj: [],
    // 加工管理
    jggl: [],
    // 茶园物联
    cywl: [],
    // 天气指数
    tqzs: [],
    // 土壤环境
    trhj: [],
    // 健康指数
    jkzs: [],
    // 指标类型
    zblx: '病虫害防控',
    // 指标趋势
    zbqs: [],
    // 农事简报
    nsjb: [],
    // 地图分布
    dtfb: [],
    // 设备信息
    sbxx: {}
  },
  getters: {},
  mutations: {
    setZblx (state, payload) {
      state.zblx = payload
    }
  },
  actions: {
    async getDTTJ ({ state }) {
      state.loading.dttj = true
      try {
        const { data } = await get({ url: '/View/ProduceStatistics' })
        state.dttj = data
      } catch (error) {
        console.log(error)
      }
      state.loading.dttj = false
    },
    async getJGGL ({ state }) {
      state.loading.jggl = true
      try {
        const { data } = await get({ url: '/View/ProductionData' })
        state.jggl = data
      } catch (error) {
        console.log(error)
      }
      state.loading.jggl = false
    },
    async getCYWL ({ state }) {
      state.loading.cywl = true
      try {
        const { data } = await get({ url: '/View/TeaIOT' })
        state.cywl = data
      } catch (error) {
        console.log(error)
      }
      state.loading.cywl = false
    },
    async getTQZS ({ state }) {
      state.loading.tqzs = true
      try {
        const { data } = await get({ url: '/View/WeatherIndex' })
        state.tqzs = data
      } catch (error) {
        console.log(error)
      }
      state.loading.tqzs = false
    },
    async getTRHJ ({ state }) {
      state.loading.trhj = true
      try {
        const { data } = await get({ url: '/View/SoilEnvironment' })
        state.trhj = data
      } catch (error) {
        console.log(error)
      }
      state.loading.trhj = false
    },
    async getJKZS ({ state }) {
      state.loading.jkzs = true
      try {
        const { data } = await get({ url: '/View/HealthIndex' })
        state.jkzs = data
      } catch (error) {
        console.log(error)
      }
      state.loading.jkzs = false
    },
    async getZBQS ({ state }, payload) {
      state.loading.zbqs = true
      try {
        const { data } = await get({ url: '/View/IndexTrend', params: { name: payload } })
        state.zbqs = data
      } catch (error) {
        console.log(error)
      }
      state.loading.zbqs = false
    },
    async getNSJB ({ state }) {
      state.loading.nsjb = true
      try {
        const { data } = await get({ url: '/View/FarmingBriefing' })
        state.nsjb = data
      } catch (error) {
        console.log(error)
      }
      state.loading.nsjb = false
    },
    async getDTFB ({ state }) {
      state.loading.dtfb = true
      try {
        const { data } = await get({ url: '/View/TerminalList' })
        state.dtfb = data
      } catch (error) {
        console.log(error)
      }
      state.loading.dtfb = false
    },
    async getSBXX ({ state }, payload) {
      state.loading.sbxx = true
      try {
        state.sbxx = {}
        const { data } = await get({ url: '/View/SensorData', params: { terminal_id: payload } })
        state.sbxx = data
      } catch (error) {
        console.log(error)
      }
      state.loading.sbxx = false
    }
  }
}
